export default "assets/logo_horse-9c5bc26d.png";